import type { ReactNode } from 'react';

import { classNames } from '../utils/class-names';
import styles from './empty-state.component.module.css';

export interface EmptyStateProps {
	/** An optional icon/illustration above the title. */
	icon?: ReactNode;
	title: ReactNode;
	description?: ReactNode;
	/** An optional action (e.g. a Button) below the copy. */
	children?: ReactNode;
	className?: string;
}

/** A centred placeholder for empty lists / zero states. */
export function EmptyState({ icon, title, description, children, className }: EmptyStateProps) {
	return (
		<div className={classNames(styles.empty, className)}>
			{icon !== undefined && <div className={styles.icon}>{icon}</div>}
			<p className={styles.title}>{title}</p>
			{description !== undefined && <p className={styles.description}>{description}</p>}
			{children !== undefined && <div className={styles.action}>{children}</div>}
		</div>
	);
}
